const config = require('../../../temp/config');
const { getCSPDirectives } = require('../../csp/csp-settings'); // adjust path to your getCSPDirectives file

/**
 * @param {import('next').NextConfig} nextConfig
 */
const corsHeaderPlugin = (nextConfig = {}) => {
  /*if (!config.sitecoreApiHost) {
    return nextConfig;
  }*/
  const disableCors = process.env.DISABLE_CORS === 'true';
  if (disableCors) {
    //console.log('CORS is disabled in the environment, not recommended');
    return nextConfig;
  }

  // Use CSP_REPORT_ONLY env variable to control report-only mode
  const cspReportOnly = process.env.CSP_REPORT_ONLY === 'true';
  const cspHeaderKey = cspReportOnly
    ? 'Content-Security-Policy-Report-Only'
    : 'Content-Security-Policy';

  return Object.assign({}, nextConfig, {
    async headers() {
      const extendHeaders =
        typeof nextConfig.headers === 'function' ? await nextConfig.headers() : [];

      // Fetch CSP directives dynamically from Sitecore
      const cspDirectives = await getCSPDirectives();

      const reportTo = JSON.stringify({
        group: 'csp-endpoint',
        max_age: 86400, // seconds (125 days)
        endpoints: [{ url: `${config.publicUrl}/api/csp-report/xt2c9f8er8` }],
      });

      return [
        ...(await extendHeaders),
        {
          source: '/_next/:path*',
          headers: [
            {
              key: 'Access-Control-Allow-Origin',
              value: config.sitecoreApiHost.replace(/\/$/, ''),
            },
            {
              key: 'Access-Control-Allow-Methods',
              value: 'GET, POST, OPTIONS',
            },
            {
              key: 'Access-Control-Allow-Headers',
              value: 'X-Requested-With, Content-Type, Authorization',
            },
          ],
        },
        {
          source: '/:path*',
          headers: [
            {
              key: 'X-DNS-Prefetch-Control',
              value: 'on',
            },
            {
              key: 'X-XSS-Protection',
              value: '1; mode=block',
            },
            {
              key: 'Access-Control-Allow-Origin',
              value: config.sitecoreApiHost.replace(/\/$/, ''),
            },
            //security scan issue fix - ticket 1090
            {
              key: 'Strict-Transport-Security',
              value: 'max-age=63072000; includeSubDomains; preload',
            },
            {
              key: cspHeaderKey,
              value: cspDirectives,
            },
            {
              key: 'Report-To',
              value: reportTo,
            },
            {
              key: 'Cross-Origin-Opener-Policy',
              value: 'same-origin',
            },
            {
              key: 'Cross-Origin-Resource-Policy',
              value: 'cross-origin',
            },
            {
              key: 'Cross-Origin-Embedder-Policy',
              value: 'unsafe-none',
            },
            { key: 'X-Content-Type-Options', value: 'nosniff' },
            { key: 'Referrer-Policy', value: 'strict-origin-when-cross-origin' },
            { key: 'Permissions-Policy', value: 'geolocation=(self), camera=(), microphone=()' },
          ],
        },
      ];
    },
  });
};

module.exports = corsHeaderPlugin;
